import { forwardRef, type Ref, type SVGProps } from "react";
const IconNoPetsFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M3.877 2.458a1.057 1.057 0 0 1 1.443.1l2.86 3.143c.131-.58.362-1.138.686-1.646a3.35 3.35 0 0 1 2.561-1.561 3.37 3.37 0 0 1 2.712 1.28 5.17 5.17 0 0 1 1.12 3.003 5.1 5.1 0 0 1-.8 3.112c-.321.54-.784.97-1.327 1.251l1.369 1.505a6.91 6.91 0 0 1 7.503 3.277l2.361 4.383a5.7 5.7 0 0 1 .585 3.82l3.662 4.023a.947.947 0 0 1-.096 1.38 1.06 1.06 0 0 1-1.368-.026l-.004-.005L3.852 3.907a1 1 0 0 0-.076-.075.947.947 0 0 1 .1-1.374m3.04 7.785.595.654c.324.436.587.954.764 1.533a4.67 4.67 0 0 1 0 2.842 2.89 2.89 0 0 1-1.861 1.941 2.4 2.4 0 0 1-.74.09 3 3 0 0 1-1.862-.68 4.67 4.67 0 0 1-1.59-2.362 4.7 4.7 0 0 1 0-2.851 2.91 2.91 0 0 1 1.84-1.912c.984-.302 2.025.008 2.854.745m18.65 6.94c.245.08.502.121.76.12.68-.01 1.336-.25 1.862-.68a4.67 4.67 0 0 0 1.59-2.362 4.7 4.7 0 0 0 0-2.851 2.762 2.762 0 0 0-4.492-1.381 4.75 4.75 0 0 0-1.581 2.371 4.67 4.67 0 0 0 0 2.842 2.89 2.89 0 0 0 1.861 1.941"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M20.253 11.5h-.16c-2.002-.11-3.483-2.202-3.352-4.673.13-2.472 1.76-4.333 3.682-4.333h.16c2.001.11 3.482 2.211 3.352 4.683S22.174 11.5 20.253 11.5"
      clipRule="evenodd"
    />
    <path d="m12.33 16.191-1.372-1.507q-.525.564-.912 1.238l-2.361 4.383a5.71 5.71 0 0 0 .82 6.594 4.9 4.9 0 0 0 3.582 1.611 4.9 4.9 0 0 0 1.902-.39l.21-.09a4.68 4.68 0 0 1 3.602 0l.2.09a4.81 4.81 0 0 0 4.738-.493L21.33 26.08z" />
  </svg>
);
const ForwardRef = forwardRef(IconNoPetsFilledSVG);
ForwardRef.displayName = "IconNoPetsFilled";
export { ForwardRef as IconNoPetsFilled };
